import React from 'react';
import { useAssessment } from '@/contexts/AssessmentContext';
import { sampleOpportunities } from '@/data/opportunities';
import { calculateScores } from '@/utils/scoringUtils';
import AssessmentFormStep from './assessment/AssessmentFormStep';
import AssessmentResultsStep from './assessment/AssessmentResultsStep';

const AssessmentSteps = () => {
  const { 
    currentStep, 
    setCurrentStep, 
    weights,
    setOpportunities,
    setScoredOpportunities,
  } = useAssessment();

  React.useEffect(() => {
    setOpportunities(sampleOpportunities);
  }, [setOpportunities]);

  const handleNext = () => {
    if (currentStep === 1) {
      const scoredOpps = calculateScores(sampleOpportunities, weights);
      setScoredOpportunities(scoredOpps);
    }
    setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <div className="container mx-auto px-4 py-8 max-w-[1400px] space-y-8">
      {currentStep === 1 && (
        <AssessmentFormStep onNext={handleNext} />
      )}

      {currentStep === 2 && (
        <AssessmentResultsStep />
      )}
    </div>
  );
};

export default AssessmentSteps;